import React from 'react'
import { Button, Tooltip } from 'antd'
import { MenuOutlined } from '@ant-design/icons'
import { checkPermission } from '../../../common/utils/helpers'

const MessageTemplateIcon = ({ onClick }) => {
  const viewMessageTemplates = checkPermission('view_message_templates')

  if (!viewMessageTemplates) {
    return null
  }

  return (
    <Tooltip title="Message templates" placement="top">
      <Button
        shape="circle"
        onClick={onClick}
        icon={<MenuOutlined />}
      >
      </Button>
    </Tooltip>
  )
}

export default MessageTemplateIcon
